var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_c('span',[_vm._v(_vm._s(_vm.isAgent ? '代办处订货系统' : '订货系统'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }